import React, { useEffect, useState } from 'react'
import OtherConfigCommonFilter from './OtherConfigCommonFilter'
import { Box, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import { getAmtAndPerOpt, getHeaderColumnDefs, getOtherCargoCol3Defs } from '../../BrnchMasterConstant'
import DropDownOA from '../../../../../common/dropDownOA'
import { Item } from '../../../../../common/snippets'
import { getFloat, navigation3 } from '../../../../../common/helper'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
import LineinputV2 from '../../../../../common/lineinputV2'
import OtherConfigCommonBottom from './OtherConfigCommonBottom'
import { callAddFontRobotoBold } from '../../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { useTranslation } from '../../../../../../i18n/I18nProvider'
const CancelLRPenaltyOnFreight = (props) => {
    const { translations } = useTranslation()
    const bum = translations?.branchAndUserMaster || {}
    const cs = translations?.common || {}
    const AmtAndPerOpt = getAmtAndPerOpt(translations)
    const headerColumnDefs = getHeaderColumnDefs(translations)
    const otherCargoCol3Defs = getOtherCargoCol3Defs(translations)

  const { tabInfo } = props
  const { resetFlag, setResetFlag, resetAllValueBrnhMaster, getBranchCargoData,
    brnhOtherCargoValue, setBrnchOtherCargoValue, onSave, confModal, setConfModal, isDisableBtn, setIsDisableBtn,
    handleBack, showBottom, setShowBottom, headerData, getPdfData, loginData } = tabInfo
  const [searchResult, setSearchResult] = useState(true)
  const [tableData, setTableData] = useState([])
  useEffect(() => {
    const fetchTableData = async () => {
      let data = await getPdfData()
      data = data.map((item, index) => {
        let penaltyType = 'NA'; // Default value for penaltyType
        let penaltyChargeType = 'NA'; // Default value for penaltyChargeType
        let chargeVal = 'NA'
        if (item?.IsLRPenaltyOnFreight === 1) {
          penaltyType = 'Penalty On Freight';
          if (item?.ChargeType?.['id'] === 1) {
            penaltyChargeType = bum.percentage || 'Percentage';
            chargeVal = item?.LRPenaltyOnFreightPer;
          } else if (item?.ChargeType?.['id'] === 2) {
            penaltyChargeType = bum.amount || 'Amount';
            chargeVal = item?.LRPenaltyOnFreightAmt;
          }
        } else if (item?.IsDocChgAsLrPenalty === 1) {
          penaltyType = 'Penalty Doc. Charge';
        }

        return {
          ...item,
          SN: index + 1,
          penaltyType: penaltyType,
          penaltyChargeType: penaltyChargeType,
          chargeValue: chargeVal,
          penaltyAfterMin: item?.IsLRPenaltyOnFreight === 0 && item?.IsDocChgAsLrPenalty === 0 ? 'NA' : item?.PenaltyAfterMinutes
        };
      });
      setTableData(data);
    };

    fetchTableData();
  }, [])
  const handleBrnhCargoValue = (value, field, prevValue) => {
    if (value != prevValue) {
      if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
        setConfModal((prev) => ({
          ...prev,
          branchOtherConfig: true
        }))
      }
      setBrnchOtherCargoValue((prev) => ({
        ...prev, [field]: value
      }))
    }
  }
  const handleBrnhAmtDropDown = (value, field, field1, field2) => {
    if (!confModal?.branchOtherConfig && isDisableBtn?.branchOtherConfig) {
      setConfModal((prev) => ({
        ...prev,
        branchOtherConfig: true
      }))
    }
    setBrnchOtherCargoValue((prev) => ({
      ...prev, [field]: value, [field1]: 0, [field2]: 0
    }))
  }

  const printClick = async (isSave = false) => {

    let pdfData = await getPdfData()

    pdfData = pdfData.map((item, index) => {
      let penaltyType = 'NA'; // Default value for penaltyType
      let penaltyChargeType = 'NA'; // Default value for penaltyChargeType
      let chargeVal = 'NA'
      if (item?.IsLRPenaltyOnFreight === 1) {
        penaltyType = 'Penalty On Freight';
        if (item?.ChargeType?.['id'] === 1) {
          penaltyChargeType = bum.percentage || 'Percentage';
          chargeVal = item?.LRPenaltyOnFreightPer;
        } else if (item?.ChargeType?.['id'] === 2) {
          penaltyChargeType = bum.amount || 'Amount';
          chargeVal = item?.LRPenaltyOnFreightAmt;
        }
      } else if (item?.IsDocChgAsLrPenalty === 1) {
        penaltyType = 'Penalty Doc. Charge';
      }

      return {
        ...item,
        SN: index + 1,
        penaltyType: penaltyType,
        penaltyChargeType: penaltyChargeType,
        chargeValue: chargeVal,
        penaltyAfterMin: item?.IsLRPenaltyOnFreight === 0 && item?.IsDocChgAsLrPenalty === 0 ? 'NA' : item?.PenaltyAfterMinutes
      };
    });
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = headerColumnDefs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfCols = otherCargoCol3Defs.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, "right")
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
    }
    doc.setProperties({
      title: `Cancel LR Penalty.pdf`,
      subject: 'Cargo Other Config',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Cargo Other Config',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 0 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: headerData,
      columnStyles: {
        0: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 16, font: 'Roboto', valign: 'middle', minCellWidth: (doc.internal.pageSize.width - 120) / 4, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 16,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },

    })
    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfCols,
      body: pdfData,
      columnStyles: {
        0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 37, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        4: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        5: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        6: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        7: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        8: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
        9: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 100, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },

      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 14,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont("Roboto", 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo Other Config | Cancel LR Penalty', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont("Roboto", 'bold')
        doc.text(`Company Name :${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(`Print: Cargo Other Config | Cancel LR Penalty`, data.settings.margin.left, 140)
        doc.text(`Branch: ${loginData?.strBranchName}`, doc.internal.pageSize.width - data.settings.margin.left, 140, "right")
        doc.text(`Date & Time: ${moment(new Date()).format('DD-MMM-YYYY, ddd, HH:mm')} `, data.settings.margin.left, 160)
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      }
    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      const pdfData = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfData);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = 'Cargo Config-Cancel LR Penalty.pdf';
      link.click();
    } else {
      // Trigger download
      const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // Open the PDF in a new tab
      window.open(pdfUrl);
    }
  }
  const InsideRowContentForExcel = ({ item, index }) => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top', fontSize: '16px' }}>
          <>
            <TableCell className="reportTD" colSpan={1} style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left' }}>
              {index + 1}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchCode}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.BranchName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.CityName}
            </TableCell>

            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.StateName}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.penaltyType}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.penaltyChargeType}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.chargeValue}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              {item.penaltyAfterMin}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }
  return (
    searchResult ?
      <>
        <OtherConfigCommonFilter
          resetAllValueBrnhMaster={() => {
            resetAllValueBrnhMaster();
            setResetFlag(!resetFlag)
          }}
          getData={getBranchCargoData} nextId='CRP-Checkbox' setShowBottom={setShowBottom} />
        <Divider />
        {showBottom && <><Grid container sx={{ padding: '6px 8px' }}>
          <Grid item md={2}>
            <Item sx={{ paddingY: "5px" }}>
              <FormControlLabel
                value="end"
                control={<Checkbox checked={brnhOtherCargoValue?.IsLRPenaltyOnFreight === 1} id='CRP-Checkbox' />}
                onKeyDown={(e) => {
                  navigation3(e, brnhOtherCargoValue?.IsLRPenaltyOnFreight === 1 ? 'charge_type' : "Cancel_LRD", brnhOtherCargoValue?.IsCargoCreditLimit === 1 ? 'to_pay' : 'credit_limitC', () => { })
                }}
                icon="reset"
                label={
                  <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                    {bum.cancelLrPenaltyOnFreight || 'Cancel LR Penalty on Freight'}
                  </Typography>
                }
                onChange={(event) => {
                  handleBrnhCargoValue(event.target.checked ? 1 : 0, 'IsLRPenaltyOnFreight', brnhOtherCargoValue?.IsLRPenaltyOnFreight)
                  if (event.target.checked) {
                    handleBrnhCargoValue(0, 'IsDocChgAsLrPenalty', brnhOtherCargoValue?.IsDocChgAsLrPenalty)
                  }
                }}
                labelPlacement="end"
              />
            </Item>
          </Grid>
          <Grid item md={2.6}>
            <Item >
              <DropDownOA
                label={bum.chargeType || 'Charge Type'}
                data={AmtAndPerOpt || []}
                defaultvalue={brnhOtherCargoValue?.ChargeType?.name || brnhOtherCargoValue?.ChargeType}
                value={brnhOtherCargoValue?.ChargeType?.name || brnhOtherCargoValue?.ChargeType}
                disabled={brnhOtherCargoValue?.IsLRPenaltyOnFreight === 0}
                onSelect={(val) => {
                  handleBrnhAmtDropDown(val, 'ChargeType', 'LRPenaltyOnFreightPer', "LRPenaltyOnFreightAmt")
                }}
                onReset={() => handleBrnhAmtDropDown('', 'ChargeType', 'LRPenaltyOnFreightPer', "LRPenaltyOnFreightAmt")}
                dataKey={'name'}
                idKey={'id'}
                id='charge_type'
                nextId={'PercentageCacelLR'}
                prevId={'Cancel_LR'}
                resetFlag={resetFlag}
                portal={true}
              />
            </Item>
          </Grid>
          <Grid item md={2.1}>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <LineinputV2
                label={brnhOtherCargoValue?.ChargeType.id === 1 ? (bum.percentage || 'Percentage') : (bum.amount || 'Amount')}
                value={brnhOtherCargoValue?.ChargeType.id === 1 ? brnhOtherCargoValue?.LRPenaltyOnFreightPer : brnhOtherCargoValue?.LRPenaltyOnFreightAmt}
                id='PercentageCacelLR'
                icon={'crossIcon'}
                filter={getFloat}
                onKeyDown={(e) => {
                  navigation3(e, "DD-CP", 'charge_type', () => { })
                }
                }
                maxLength={brnhOtherCargoValue?.ChargeType.id === 1 ? 3 : 4}
                onBlur={(event) => {
                  handleBrnhCargoValue(Number(event.target.value) > 100 && brnhOtherCargoValue?.ChargeType.id === 1 ? 100 : event.target.value, brnhOtherCargoValue?.ChargeType.id === 1 ? 'LRPenaltyOnFreightPer' : 'LRPenaltyOnFreightAmt', brnhOtherCargoValue?.ChargeType.id === 1 ? brnhOtherCargoValue?.LRPenaltyOnFreightPer : brnhOtherCargoValue?.LRPenaltyOnFreightAmt)
                }}
                resetCallback={() => {
                  handleBrnhCargoValue('', brnhOtherCargoValue?.ChargeType.id === 1 ? 'LRPenaltyOnFreightPer' : 'LRPenaltyOnFreightAmt', ' ')
                }}
                disabled={brnhOtherCargoValue?.IsLRPenaltyOnFreight === 0}
              />
            </Item>
          </Grid>
          <Grid item md={2} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }}>
            <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>{bum.orUpper || 'OR'}</Typography>
            <Item className={'input--wrapper btmSpaceNotRequired'}>
              <FormControlLabel
                value="end"
                control={<Checkbox checked={brnhOtherCargoValue?.IsDocChgAsLrPenalty === 1} id='DD-CP' />}
                onKeyDown={(e) => {
                  navigation3(e, brnhOtherCargoValue?.IsLRPenaltyOnFreight === 1 || brnhOtherCargoValue?.IsDocChgAsLrPenalty === 1 ? 'cancel_amin' : "bus", brnhOtherCargoValue?.IsLRPenaltyOnFreight === 1 ? 'PercentageCacelLR' : 'Cancel_LR', () => { })
                }}
                label={
                  <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                    {bum.debitDocumentChargePenalty || 'Debit Document Charge Penalty'}
                  </Typography>
                }
                onChange={(event) => {
                  handleBrnhCargoValue(event.target.checked ? 1 : 0, 'IsDocChgAsLrPenalty', brnhOtherCargoValue?.IsDocChgAsLrPenalty)
                  if (event.target.checked) {
                    handleBrnhCargoValue(0, 'IsLRPenaltyOnFreight', brnhOtherCargoValue?.IsLRPenaltyOnFreight)
                  }
                }}
                labelPlacement="end"
              />
            </Item>
          </Grid>
          <Grid item md={2.6}>
            <Item sx={{ paddingY: "5px" }} className={'input--wrapper btmSpaceNotRequired'}>
              <LineinputV2
                label={bum.cancellationAfterMinute || 'Cancellation After Minute'}
                value={brnhOtherCargoValue?.PenaltyAfterMinutes}
                id='cancel_amin'
                icon={'crossIcon'}
                filter={getFloat}
                onKeyDown={(e) => {
                  navigation3(e, "cancelBtn", 'DD-CP', () => { })
                }}
                onBlur={(event) => {
                  handleBrnhCargoValue(event.target.value, 'PenaltyAfterMinutes', brnhOtherCargoValue?.PenaltyAfterMinutes)
                }}
                resetCallback={(event) => {
                  handleBrnhCargoValue(0, 'PenaltyAfterMinutes', ' ')
                }}
                disabled={brnhOtherCargoValue?.IsLRPenaltyOnFreight === 0 && brnhOtherCargoValue?.IsDocChgAsLrPenalty === 0}
              />
            </Item>
          </Grid>
        </Grid>
          <Divider />
          <OtherConfigCommonBottom onSave={onSave} handleBack={handleBack} printClick={printClick} setSearchResult={setSearchResult} fileName={'cancelLrPenaltyOnFreight'} />
        </>

        }
        <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)' }}>
          {/* ---------------Table For Excel--------------- */}
          <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              {/* -------TableHeader--------- */}
              <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                <TableCell className="reportTD" colSpan={4}>
                  {bum.reportForCancelLrPenalityOnFreight || 'Report For: Cancel LR Penality On Freight'}
                </TableCell>
                <TableCell className="reportTD" colSpan={4}>
                  {bum.companyNameMavenTechServicesPvtLtd || 'Company Name : _Maven Tech Services Pvt. Ltd.'}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {headerColumnDefs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={2}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
              {headerData?.map((item, i) => (
                <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.CompanyName}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.State}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.City}</span>
                  </TableCell>
                  <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                    <span>{item?.Branch}</span>
                  </TableCell>
                </TableRow>))}
              <TableRow>
                <TableCell colSpan={12}></TableCell>
              </TableRow>
              <TableRow style={{ fontSize: '16px', verticalAlign: 'top' }}>
                {otherCargoCol3Defs?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                    colSpan={1}
                    key={i}
                  >
                    {item.headerName}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={11}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                        }}
                      >
                        <span>{cs.noResultsFound || 'No results found. Please refine your search parameters and search again.'}</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  fontWeight: '500',
                  marginLeft: '5px',
                }}
              >
                {tableData?.map((item, index) => (
                  <InsideRowContentForExcel item={item} index={index} key={index} />
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </>
      :
      <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
        <object
          id="cancelPenaltyOutput"
          type="application/pdf"
          width="100%"
          height="200"
          title={bum.mtlplCargoSystemCargoConfigCancelLrPenalty || 'MTLPL -Cargo System - Cargo Config - Cancel LR Penalty'}
          aria-label={bum.mtlplCargoSystemCargoConfigCancelLrPenalty2 || 'MTLPL -Cargo System - Cargo Config- Cancel LR Penalty'}
        ></object>
      </Box>
  )
}

export default CancelLRPenaltyOnFreight
